<template>
  <div>
    <div class="file-head">
      <div class="file-step-wrapper">
        <div class="file-step-arr">
          <div class="file-step-item" v-for="(item, index) in gradeList" :key="index" @click="goBackStep(index)">
            <div class="file-step-item-title">{{ item.title }}</div>
            <img src="@/assets/ic_right.png" alt="" />
          </div>
          <div class="file-stop-last" :class="{'file-stop-last-active': gradeList.length == 0}">{{ currentDir.title }}</div>
        </div>
      </div>
      <div class="sort-body">
        <div class="sort-title" @mouseenter="showSort" @mouseleave="hideSort">{{ orderbyName }}</div>
        <div class="sort-icon" :class="{'sort-icon-active': sort == 'desc'}" @click="changeSort"><img src="@/assets/ic_sort.png" alt=""></div>
        <div class="sort-options" 
              v-if="sortIsHovered || sortIsHoveredTemp" 
              @mouseenter="showSortTemp" 
              @mouseleave="hideSortTemp"
              :style="{ top: sortPosition.top + 'px', left: sortPosition.left + 'px' }">
          <div class="sort-options-item" 
              :class="{'sort-options-item-title-select': orderby == item.value}" 
              v-for="(item, index) in orderByOptions" :key="index"
              @click="clickSort(item.value, item.label)">
            <div class="sort-options-item-title">{{ item.label }}</div>
            <div class="sort-options-item-icon" v-if="orderby == item.value">
              <img src="@/assets/ic_sort_select.png" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="file-tab">
      <div class="file-tab-title">
        <div class="file-tab-title-body">
          <div class="file-tan-title-ic" @click="clickSelectedAll">
            <img v-if="!selectedAll" src="@/assets/ic_selected_n.png" alt="" />
            <img v-else src="@/assets/ic_selected_y.png" alt="" />
          </div>
          <div class="file-title">文件</div>
        </div>
        <!-- <div class="file-back" @click="goBack" v-if="gradeList.length > 0">
          <div class="ic">
            <img src="@/assets/ic_back.png" alt="" />
          </div>
          <div>返回</div>
        </div> -->
      </div>
    </div>
    <div class="tab-content-file" ref="scrollContainer" v-if="currentDir.subs.length > 0">
      <file-item @clickSelectedItem="clickSelectedItem" @click.native="clickFileItem(item)" :file-item="item" v-for="(item, index) in currentDir.subs" :key="index"></file-item>
    </div>
    <div ref="scrollContainer" v-else>
      <empty></empty>
    </div>
  </div>
</template>

<script>
  // 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
  // 例如：import 《组件名称》 from '《组件路径》';
  import { throttle } from 'lodash';
  import { diskIndex, diskSearch } from '@/utils/api/apis.js'
  import fileItem from '../file_item.vue'
  import empty from '@/components/empty.vue';
  export default {
    // import引入的组件需要注入到对象中才能使用
    components: {
      fileItem,
      empty
    },
    props: {
      // 文件类型0=文件夹,1=图片,2=视频,3=音频,4=txt文件,5=word文件,6=pdf,7=excel,8=压缩包,100=其他
      type: {
        type: String,
        required: true
      },
      searchValue: {
        type: String,
        required: true
      },
      dirId: {
        type: Number,
        default: 0
      }
    },
    data() {
      // 这里存放数据
      return {
        lastScrollTop: 0, // 记录上次的滚动位置
        selectedAll: false,
        formData: {
          dir_id: -1,
          page: 1,
          pagesize: 20,
          orderby: '',
          sort: '',
          source: '',
          type: '',
          word: ''
        },
        currentDir: {
        	title: '全部文件',
        	subs: [],
          total: 0
        },
        gradeList: [],
        // 排序字段选项
        orderByOptions: [
          { label: '综合排序', value: ''},
          { label: '创建日期', value: 'createtime'},
          { label: '文件名称', value: 'name'},
          { label: '文件大小', value: 'size'}
        ],
        // // 排序规则选项
        // sortOptions: [
        //   { label: '降序', value: 'desc' },
        //   { label: '升序', value: 'asc' }
        // ],
        // 当前选中的排序字段和规则
        orderby: '',
        orderbyName: '综合排序',
        sort: 'desc', // asc
        sortIsHovered: false,
        sortIsHoveredTemp: false,
        sortPosition: { top: 0, left: 0 },
      }
    },
    // 过滤器
    filters: {},
    // 监听属性 类似于data概念
    computed: {},
    // 监控data中的数据变化
    watch: {
      searchValue(newVal) {
        this.formData.word = newVal
        this.formData.page = 1
        this.currentDir.subs = [];
        this.getDiskIndex()
      }
    },
    // 方法集合
    methods: {
      // 加载更多
      handleScroll: throttle(function () {
        const container = this.$refs.scrollContainer;
        const scrollTop = container.scrollTop;

        // 检查是否滚动到底部，且滚动方向是向下
        if (scrollTop > this.lastScrollTop && scrollTop + container.clientHeight >= container.scrollHeight) {
          if (this.currentDir.total <= this.currentDir.subs.length) return;
          this.formData.page++;
          this.getDiskIndex();
        }
        this.lastScrollTop = scrollTop;
      }, 100),
      async getDiskIndex({isShowLoading = false} = {}) {
        try{
          if (isShowLoading) {
            this.$dialog.loading.show()
          }
          var base;
          if (this.formData.word != '') {
            base = await diskSearch(this.formData);
          } else {
            base = await diskIndex(this.formData);
          }
          base.data.list.forEach((item) => {
            if (item.data_type != 3) {
              item.selected = this.selectedAll
            }
          });
          if (this.formData.page == 1) {

            this.currentDir.subs = base.data.list
            this.currentDir.total = base.data.total
          } else {
            this.currentDir.subs = this.currentDir.subs.concat(base.data.list)
          }
          this.getSelectItem()
          if (isShowLoading) {
            this.$dialog.loading.hide()
          }
        }catch(e){
          if (isShowLoading) {
            this.$dialog.loading.hide()
          }
          this.$toast(e)
          if (this.formData.page > 1) {
            this.formData.page--
          }
          this.$errorLog('tab_file/getDiskIndex', e)
        }
      },
      clickSelectedAll() {
        this.selectedAll = !this.selectedAll
        this.currentDir.subs.forEach(item => {
          if (item.data_type !== 3) item.selected = this.selectedAll;
        });
        this.getSelectItem()
      },
      clickSelectedItem(data) {
        data.selected = !data.selected
        this.selectedAll = this.currentDir.subs
            .filter(item => item.data_type !== 3)
            .every(item => item.selected);
        this.getSelectItem()
      },
      async clickFileItem(item) {
        if (item.is_dir != 1) {
          return;
        }
        this.currentDir.subs.forEach(item => {
          if (item.data_type !== 3) item.selected = false;
        });
        this.$emit('changeDirId', item)
        // 记录当前层级的文件夹信息，便于返回上一级
        this.gradeList.push({
          ...this.currentDir,
          page: this.formData.page,// 将当前页码记录
          scrollTop: this.lastScrollTop,
          id: this.formData.dir_id
        });

        this.currentDir.title = item.title
        // 更新目录ID并重新请求数据
        this.formData.dir_id = item.id;
        this.formData.page = 1; // 重新加载时从第一页开始
        await this.getDiskIndex({isShowLoading: true}); // 加载文件夹内容
        // 滚动回顶部
        this.$nextTick(() => {
          this.$refs.scrollContainer.scrollTop = 0;
        });
      },
      // 返回上一级目录
      // async goBack() {
      //   if (this.gradeList.length > 0) {
      //     this.selectedAll = false;
      //     // 从 gradeList 中弹出上一级数据
      //     const previousDir = this.gradeList.pop();
      //     // 设置为上一级目录并更新dir_id
      //     this.currentDir = previousDir;
      //     this.formData.page = previousDir.page;
      //     this.formData.dir_id = previousDir.id || 0;
      //     this.$emit('changeDirId', {id: this.formData.dir_id})
      //     // 恢复滚动位置
      //     this.$nextTick(() => {
      //       this.$refs.scrollContainer.scrollTop = previousDir.scrollTop || 0;
      //     });
      //     this.getSelectItem()
      //     this.formData.page = 1
      //     this.getDiskIndex()
      //   }
      // },
      goBackStep(index) {
        this.selectedAll = false;
        // 从 gradeList 中弹出上一级数据
        // 获取指定索引的目录数据
        const previousDir = this.gradeList[index];
        // 清除该索引及之后的数据
        this.gradeList = this.gradeList.slice(0, index);
        // 设置为上一级目录并更新dir_id
        this.currentDir = previousDir;
        this.formData.page = previousDir.page;
        this.formData.dir_id = previousDir.id || 0;
        this.$emit('changeDirId', {id: this.formData.dir_id})
        // 恢复滚动位置
        this.$nextTick(() => {
          this.$refs.scrollContainer.scrollTop = previousDir.scrollTop || 0;
        });
        this.getSelectItem()
        this.formData.page = 1
        this.getDiskIndex()
      },
      getSelectItem() {
        var tempArr = [];
        this.currentDir.subs.forEach((item) => {
          if (item.selected) {
            tempArr.push(item)
          }
        })
        this.$emit('selectionList', tempArr)
      },
      removeSelectedItem() {
        const filteredItems = this.currentDir.subs.filter(item => !item.selected);
        this.currentDir.subs = filteredItems
      },
      cleanAllSelected() {
        this.selectedAll = false;
        this.currentDir.subs.forEach(item => {
          item.selected = false;
        });
        
        this.getSelectItem()
      },
      showSort(event) {
        this.sortIsHovered = true
        const rect = event.target.getBoundingClientRect();
        this.sortPosition = {
          top: rect.bottom + window.scrollY + 6, // 距离顶部的位置
          left: rect.left + window.scrollX - 86, // 距离左侧的位置
        };
      },
      hideSort() {
        setTimeout(() => {
          this.sortIsHovered = false
        }, 500)
      },
      showSortTemp() {
        this.sortIsHoveredTemp = true
      },
      hideSortTemp() {
        this.sortIsHoveredTemp = false
      },
      clickSort(value, label) {
        this.orderby = value
        this.orderbyName = label
        this.sortIsHoveredTemp = false
        this.formData.page = 1;
        this.formData.orderby = value
        this.getDiskIndex({isShowLoading: true})
      },
      changeSort() {
        this.sort = this.sort == 'desc' ? 'asc' : 'desc'
        this.formData.page = 1;
        this.formData.sort = this.sort
        this.getDiskIndex({isShowLoading: true})
      }
    },
    // 生命周期 - 创建完成（可以访问当前this实例）
    created() {},
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
      this.formData.type = this.type
      this.formData.word = this.searchValue
      this.formData.dir_id = this.type == '' ? 0 : -1
      this.$refs.scrollContainer.addEventListener('scroll', this.handleScroll);
      this.getDiskIndex({isShowLoading: true})
    },
    beforeCreate() {}, // 生命周期 - 创建之前
    beforeMount() {}, // 生命周期 - 挂载之前
    beforeUpdate() {}, // 生命周期 - 更新之前
    updated() {}, // 生命周期 - 更新之后
    beforeDestroy() {
      this.$refs.scrollContainer.removeEventListener('scroll', this.handleScroll);
    }, // 生命周期 - 销毁之前
    destroyed() {}, // 生命周期 - 销毁完成
    ctivated() {} // 如果页面有keep-alive缓存功能，这个函数会触发
  }
</script>

<style lang='scss' scoped>
  .file-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 64px;
    box-sizing: border-box;
    padding: 0 24px;
    gap: 16px; // 添加间距
    .file-step-wrapper {
      position: relative; // 添加相对定位
      flex: 1;
      width: 0; // 关键：添加width: 0确保flex-basis为0
      min-width: 0; // 关键属性：允许flex子项收缩到比其内容更小
      overflow-x: auto;
      overflow-y: hidden;
      
      // 隐藏滚动条但保持功能
      scrollbar-width: none; // Firefox
      &::-webkit-scrollbar {
        display: none; // Chrome, Safari, Opera
      }
    }
    .file-step-arr {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      height: 100%;
      min-width: min-content; // 确保内容不会被压缩
      .file-step-item {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 15px;
        font-weight: bold;
        color: #000;
        .file-step-item-title {
          max-width: 100px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        cursor: pointer;
        img {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 24px;
          height: 24px;
        }
      }
      .file-step-item:first-child{
        font-size: 18px;
      }
      .file-stop-last {
        font-size: 15px;
        font-weight: bold;
        color: rgba(153, 153, 153, 1);
        max-width: 100px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .file-stop-last-active {
        font-size: 18px;
      }
    }
    .sort-body {
      flex-shrink: 0; // 防止被压缩
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      .sort-title {
        font-size: 16px;
        color: rgba(102, 102, 102, 1);
        margin-right: 10px;
      }
      .sort-icon {
        width: 12px;
        height: 19px;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: 12px;
          height: 19px;
        }
      }
      .sort-icon-active {
        transform: rotate(180deg);
      }
      .sort-options {
        position: absolute;
        width: 172px;
        height: auto;
        background-color: white;
        border-radius: 10px;
        border: 1px solid rgba(204, 204, 204, 1);
        box-sizing: border-box;
        padding: 18px 14px 18px 18px;
        .sort-options-item {
          display: flex;
          align-items: center;
          justify-content: space-between;
          font-size: 16px;
          color: rgba(102, 102, 102, 1);
          cursor: pointer;
          margin-bottom: 20px;
          .sort-options-item-title {
            font-size: 16px;
            font-weight: bold;
          }
          .sort-options-item-icon {
            width: 14px;
            height: 14px;
            display: flex;
            align-items: center;
            justify-content: center;
            img {
              width: 14px;
              height: 14px;
            }
          }
        }
        .sort-options-item-title-select {
          color: rgba(74, 131, 255, 1);
        }
        .sort-options-item:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
  .file-tab {
    height: 40px;
    padding: 0 24px;
    .file-tab-title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 100%;
      font-size: 15px;
      font-weight: bold;
      .file-tab-title-body {
        display: flex;
        align-items: center;
        .file-tan-title-ic {
          width: 14px;
          height: 14px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 22px;
          img {
            width: 14px;
            height: 14px;
          }
        }
        .file-tan-title-ic:hover {
          cursor: pointer;
        }
      }
      .file-back {
        display: flex;
        align-items: center;
        .ic {
          width: 24px;
          height: 24px;
          display: flex;
          align-items: center;
          justify-content: center;
          /* margin-right: 12px; */
          img {
            width: 24px;
            height: 24px;
          }
        }
      }
    }
  }
  .tab-content-file {
    height: calc(100vh - 304px);
    overflow-y: auto;
    scrollbar-width: none; /* Firefox */

    &::-webkit-scrollbar {
      display: none; /* Chrome, Safari, Opera */
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/tabs/tab_file.vue